export const ChatListConstant = {
  // Identify system lists by list_type (not by name, which may be localised client-side)
  LIST_TYPE: {
    FAVOURITE: 'favourite',
    ARCHIVE: 'archive',
    CUSTOM: 'custom',
  },

  // Debounce window (ms) before re-pulling the chat lists after a chat_list_update presence
  PRESENCE_RELOAD_DEBOUNCE_MS: 500,

  LOCAL_STORAGE: {
    // Persisted local copy of the chat lists (per-list updated_at + chat ids) — the working
    // copy the app compares against on pull and writes through to on push.
    LISTS: 'CL',
    // localStorage marker holding the user_id whose legacy FC/AC lists have been
    // seeded up to an empty server the first time, so it never runs twice.
    MIGRATED_USER_ID: 'CLMU',
  },
};
